import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Form,
  Label,
  Button,
  ButtonGroup,
  FormGroup,
  Input,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap"
import "react-datepicker/dist/react-datepicker.css"
import { useTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import { is_empty } from "../../config/validate"
//redux
import { useSelector, useDispatch } from "react-redux"
import moment from "moment"
import {
  cleanMaterial,
  saveMaterial,
  updateMaterial,
  saveMassiveCharge,
} from "../../store/actions"
import showToast from "../../components/Common/viewNotification"
import AsyncSelect from "react-select/async"
import service from "../../api/monitor.service"
import { Tabs, TabList, Tab, TabPanel } from "react-tabs"
import "react-tabs/style/react-tabs.css"
import * as XLSX from "xlsx"
const MaterialSupplierForm = props => {
  
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // eslint-disable-next-line react/prop-types
  const { onClosing, currentMaterial, onLoad, isEdit } = props
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [id, setId] = useState({ value: "", error: "" })
  const [data, setData] = useState({
    enableImport: false,
    fileUpload: null,
  })

  const [codeSap, setCodeSap] = useState({
    value: "",
    label: "",
    error: "",
  })
  const [name, setName] = useState({
    value: "",
    label: "",
    error: "",
  })
  const [description, setDescription] = useState({
    value: "",
    label: "",
    error: "",
  })
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  let [errors, setErrors] = useState([])
  const [supplier, setSupplier] = useState({
    value: 0,
    label: t("monitor:supplierFind"),
    error: "",
  })

  const { loadingSave, response, error, loadingSupplier, loading } =
    useSelector(state => ({
      loading: state.materialSupplier.loadingSave,
      response: state.materialSupplier.response,
      error: state.materialSupplier.error,
    }))

  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
      dispatch(cleanMaterial())
    }
  }, [error])
  useEffect(() => {
    if (response !== null) {
      showToast(t("global:msgSuccessSaveList"), "success", t("global:config"))
      if (isEdit) onClosing(true)
      clearForm()
      dispatch(cleanMaterial())
      onLoad()
    }
  }, [response])
  useEffect(() => {
    if (currentMaterial) setDataRow()
  }, [currentMaterial])

  const handleSubmit = async () => {
    validate()
    if (errors.length === 0) {
      let values = {
        id: id.value,
        supplier: {
          id: supplier?.id,
        },
        name: name.value,
        codeSap: codeSap.value,
        description: description.value,
        createDate: moment().format("YYYY-MM-DD"),
        createdBy: auth.id.user.username,
        status: 1,
      }

      if (values?.id) {
        await dispatch(updateMaterial(values))
      } else {
        await dispatch(saveMaterial(values))
      }
    }
  }
  const validate = () => {
    errors = []
    if (is_empty(name.value)) {
      name.error = t("error:required")
      errors.push(name.error)
    }
    if (is_empty(codeSap.value)) {
      codeSap.error = t("error:required")
      errors.push(codeSap.error)
    }
    if (is_empty(description.value)) {
      description.error = t("error:required")
      errors.push(description.error)
    }
    if (!supplier?.id) {
      supplier.error = t("error:required")
      errors.push(supplier.error)
    }
    setErrors(errors)
  }
  const loadSuppliers = filter => {
    if (auth) {
      const json = {
        username: auth?.id?.user?.username,
        length: 30,
        filter,
        societyCode: process.env.REACT_APP_STYLE_TEMPLATE,
      }
      return service.getSupplier(json)
    }
  }

  const loadingOptionSupplier = async (filter, callback) => {
    if (filter.length >= 3) {
      const data = await loadSuppliers(filter)
      const s = data?.data?.map(item => {
        return {
          ...item,
          value: item.code,
          label: item.name + " | " + item.code,
        }
      })
      callback(s)
    }
  }
  const onChangeSupplier = (value, action) => {
    setSupplier(value)
  }
  const clearForm = async () => {
    setId({ value: "", error: "" })
    setName({ value: "", label: "", error: "" })
    setCodeSap({ value: "", label: "", error: "" })
    setDescription({ value: "", label: "", error: "" })
    if (isEdit)
      setSupplier({
        value: 0,
        label: t("monitor:supplierFind"),
        error: "",
      })
  }
  const setDataRow = () => {
    setId({ value: currentMaterial.id, error: "" })
    setName({ value: currentMaterial.name, error: "" })
    setDescription({ value: currentMaterial.description, error: "" })
    setCodeSap({ value: currentMaterial.codeSap, error: "" })
    setSupplier({
      value: currentMaterial.supplier.id,
      label: currentMaterial.supplier.name,
      error: "",
      id: currentMaterial.supplier.id,
    })
  }
  const importXls = async () => {
    if (!data.fileUpload) {
      showToast(
        t("materialSupplier:errorSelectFile"),
        "error",
        t("materialSupplier:title")
      )
      return
    }
    const firstSheet = data.fileUpload.SheetNames[0]
    const excelRows = XLSX.utils.sheet_to_row_object_array(
      data.fileUpload.Sheets[firstSheet]
    )
    const materialList = []
    for (const row of excelRows) {
      const aux = {
        supplier: {
          code: row["PROVEEDOR(CODIGO)"],
        },
        name: row["NOMBRE"],
        codeSap: row["CODIGO SAP"],
        description: row["DESCRIPCION"],
      }

      materialList.push(aux)
    }
    let body = {
      materialList: materialList,
      username: auth?.id?.user?.username,
    }
    await dispatch(saveMassiveCharge(body))
  }

  const getLayoutXls = () => {
    var ws = XLSX.utils.json_to_sheet([
      {
        "PROVEEDOR(CODIGO)": "",
        NOMBRE: "",
        "CODIGO SAP": "",
        DESCRIPCION: "",
      },
    ])
    var wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Datos")
    XLSX.writeFile(wb, "Carga Masiva materiales.xlsx")
  }
  const handleFileUpload = e => {
    e.preventDefault()
    let files = e.target.files
    if (files.length > 0) {
      let fileUpload = files[0]
      fileUpload.type
      const regex = /^.*\.(xls|xlsx|XLS|XLSX)$/
      if (regex.test(fileUpload.name.toLowerCase())) {
        var fileReader = new FileReader()
        fileReader.onload = e => {
          var oFile = XLSX.read(e.target.result, { type: "array" })
          data.enableImport = true
          data.fileUpload = oFile
          updateState(true, "enableImport")
        }
        fileReader.readAsArrayBuffer(fileUpload)
      } else {
        data.enableImport = false
        showToast(
          t("materialSupplier:errorTypeFile"),
          "error",
          t("materialSupplier:title")
        )
        updateState(false, "enableImport")
      }
    }
  }
  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    })
  }
  const handleSelect = index => {
    setActiveTabIndex(index)
  }

  return (
    <Tabs selectedIndex={activeTabIndex} onSelect={handleSelect}>
      <TabList>
        <Tab>Registro</Tab>
        <Tab>Carga Masiva</Tab>
      </TabList>

      <TabPanel>
        <Form>
          <Row>
            <Col>
              <div className="mb-2">
                <Form className="row gy-2 gx-3 align-items-center">
                  <FormGroup className="mb-0">
                    {" "}
                    <Label>{t("materialSupplier:titleSupplier")} </Label>
                    <div className="d-flex flex-row align-items-center gap-2">
                      <div className="flex-grow-1">
                        <AsyncSelect
                          loadOptions={loadingOptionSupplier}
                          maxMenuHeight={150}
                          cacheOptions
                          className="small-font text-uppercase"
                          isDisabled={loading}
                          placeholder={t("monitor:supplierFind")}
                          name="supplier"
                          isClearable
                          isLoading={loadingSupplier}
                          onChange={(value, action) => {
                            onChangeSupplier(value, action)
                          }}
                          value={supplier}
                        />
                        <span className="small text-danger">
                          {supplier?.error}
                        </span>
                      </div>
                    </div>
                  </FormGroup>
                </Form>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={6}>
              <div className="mb-2">
                <Label htmlFor="name">
                  {t("materialSupplier:titleNameMaterial")}
                </Label>

                <Input
                  autoComplete="new-text"
                  type="text"
                  className="form-control"
                  value={name.value || ""}
                  onChange={e => {
                    setName({ value: e.target.value, error: "" })
                  }}
                  invalid={!is_empty(name.error)}
                />
                <span className="small text-danger">{name.error}</span>
              </div>
            </Col>
            <Col xs={6}>
              <div className="mb-2">
                <Label htmlFor="name">
                  {t("materialSupplier:titleCodeSap")}
                </Label>

                <Input
                  autoComplete="new-text"
                  type="text"
                  className="form-control"
                  value={codeSap.value || ""}
                  onChange={e => {
                    setCodeSap({ value: e.target.value, error: "" })
                  }}
                  invalid={!is_empty(codeSap.error)}
                />
                <span className="small text-danger">{codeSap.error}</span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="mb-2">
                <Label htmlFor="name">
                  {t("materialSupplier:titleDescription")}
                </Label>

                <Input
                  autoComplete="new-text"
                  type="textarea"
                  className="form-control"
                  value={description.value || ""}
                  onChange={e => {
                    setDescription({ value: e.target.value, error: "" })
                  }}
                  invalid={!is_empty(description.error)}
                />
                <span className="small text-danger">{description.error}</span>
              </div>
            </Col>
          </Row>
        </Form>
      </TabPanel>

      <TabPanel>
        <FormGroup>
          <Label className="form-label">Carga Masiva</Label>
          <div className="d-flex">
            <div className="flex-grow-1 me-2">
              <Input
                type="file"
                name="file"
                id="fileUpload"
                className="form-control"
                onChange={handleFileUpload}
              />
            </div>
            <UncontrolledDropdown group>
              <Button className="btn btn-success" onClick={() => importXls()}>
                <i className="fas fa-upload"></i>

                {t("materialSupplier:titleupFile")}
              </Button>
              <DropdownToggle caret color="info">
                {t("materialSupplier:titleExport")}
                <i className=" fas fa-caret-down me-1 " />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={getLayoutXls}>
                  <span className="">
                    <i className="text-success fas fa-file-excel me-1 " />
                    {t("materialSupplier:titleExportLayout")}
                  </span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </FormGroup>
      </TabPanel>
      <div className="modal-footer mt-3">
        <ButtonGroup>
          {activeTabIndex === 0 && (
            <button
              type="button"
              className="btn btn-info save-user"
              onClick={handleSubmit}
            >
              <i className="fas fa-save me-1" />
              {t("global:save")}
            </button>
          )}
          <button
            type="button"
            className="btn btn-danger"
            disabled={loadingSave}
            onClick={() => onClosing(true)}
          >
            {t("global:close")}
          </button>
        </ButtonGroup>
      </div>
    </Tabs>
  )
}
export default withRouter(MaterialSupplierForm)
